
<div class="v-flex">
    <c-import-quality-tag
        :count = "getCount(item, 3)"
        color  = "error"
    />
    <c-import-quality-tag
        :count = "getCount(item, 2)"
        color  = "warning"
    />
    <c-import-quality-tag
        :count = "getCount(item, 1)"
        color  = "success"
    />
</div>
